import { render, staticRenderFns } from "./thatYearYield.vue?vue&type=template&id=2341edd9&scoped=true"
import script from "./thatYearYield.vue?vue&type=script&lang=js"
export * from "./thatYearYield.vue?vue&type=script&lang=js"
import style0 from "./thatYearYield.vue?vue&type=style&index=0&id=2341edd9&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2341edd9",
  null
  
)

export default component.exports